export default __webpack_public_path__ + "static/media/graduation_headshot.9c5e013a.webp";